import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "../../../contexts/ThemeContext";
import type { ThemeMode } from "../../../types";

const themeOptions: Array<{
  mode: ThemeMode;
  icon: React.ReactNode;
  label: string;
}> = [
  { mode: "light", icon: <Sun size={14} />, label: "Light" },
  { mode: "dark", icon: <Moon size={14} />, label: "Dark" },
  { mode: "system", icon: <Monitor size={14} />, label: "System" },
];

const pillPositions: Record<ThemeMode, string> = {
  light: "left-1",
  dark: "left-[33.333%]",
  system: "left-[66.666%]",
};

export default function AppearanceSettings() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-warm-text-primary mb-2">Theme</h3>
        <p className="text-sm text-warm-text-secondary mb-4">
          Choose how JuDI looks to you. Select a theme or sync with your system
          settings.
        </p>
      </div>

      <div
        className="relative grid grid-cols-3 rounded-full p-1 bg-warm-bg-elevated border border-warm-border"
        role="group"
        aria-label="Theme"
      >
        {/* Sliding pill */}
        <div
          aria-hidden="true"
          className={`absolute top-1 bottom-1 w-[calc(33.333%-2.67px)] rounded-full bg-warm-blue shadow-soft-sm transition-[left] duration-200 ease-out ${pillPositions[theme]}`}
        />
        {themeOptions.map((option) => {
          const isSelected = theme === option.mode;
          return (
            <button
              key={option.mode}
              onClick={() => setTheme(option.mode)}
              aria-pressed={isSelected}
              className={`relative z-10 flex items-center justify-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium transition-colors duration-150 ease-in-out ${
                isSelected
                  ? "text-white"
                  : "text-warm-text-secondary hover:text-warm-text-primary"
              }`}
            >
              {option.icon}
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
